import { render, staticRenderFns } from "./livestockBornBetweenTwoDates.vue?vue&type=template&id=b0d535aa&scoped=true&"
import script from "./livestockBornBetweenTwoDates.vue?vue&type=script&lang=js&"
export * from "./livestockBornBetweenTwoDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d535aa",
  null
  
)

export default component.exports